module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/more.6844b.png";